import { AppBar, Toolbar, Typography, IconButton, Button, Container, Box, Avatar, Stack } from "@mui/material";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import ForumRoundedIcon from '@mui/icons-material/ForumRounded';
import { Link, useNavigate } from "react-router-dom";
import { clearToken, getToken } from "../api/client";
import { useEffect, useState } from "react";

export default function AppShell({
  mode,
  toggleMode,
  children,
}: {
  mode: "light" | "dark";
  toggleMode: () => void;
  children: React.ReactNode;
}) {
  const navigate = useNavigate();
  const token = getToken();
  const [username, setUsername] = useState<string>("");

  useEffect(() => {
      if (token) {
          import("../api/profile").then(({ getMyProfile }) => {
              getMyProfile().then(p => setUsername(p.username)).catch(() => {});
          });
      } else {
          setUsername("");
      }
  }, [token]);

  const handleLogout = () => {
    clearToken();
    navigate("/login");
  };

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default", color: "text.primary" }}>
      <AppBar position="sticky" color="inherit" elevation={0} sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Container maxWidth={false} sx={{ px: { xs: 2, md: 4 } }}>
          <Toolbar disableGutters>
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mr: 4 }}>
                <ForumRoundedIcon sx={{ fontSize: 32, color: 'primary.main' }} />
                <Typography
                variant="h6"
                component={Link}
                to="/"
                sx={{
                    fontWeight: 800,
                    color: "text.primary",
                    textDecoration: "none",
                    letterSpacing: "-0.03em",
                    fontSize: '1.5rem'
                }}
                >
                Threadly
                </Typography>
            </Stack>
            
            <Box sx={{ flexGrow: 1 }} /> {/* Spacer */}

            <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
              <IconButton color="inherit" onClick={toggleMode} size="small">
                {mode === "dark" ? <LightModeIcon /> : <DarkModeIcon />}
              </IconButton>
              
              {!token ? (
                <>
                  <Button color="inherit" onClick={() => navigate("/login")}>
                    Sign In
                  </Button>
                  <Button 
                    variant="contained" 
                    color="primary"
                    onClick={() => navigate("/register")} 
                    disableElevation
                  >
                    Register
                  </Button>
                </>
              ) : (
                <>
                  <IconButton onClick={() => navigate("/profile")} sx={{ p: 0.5, border: 1, borderColor: 'divider' }}>
                    <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem', bgcolor: 'primary.main' }}>
                        {username ? username[0].toUpperCase() : "U"}
                    </Avatar>
                  </IconButton>
                  <Button color="inherit" onClick={handleLogout}>
                    Logout
                  </Button>
                </>
              )}
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <Box sx={{ minHeight: 'calc(100vh - 65px)' }}>
          {children}
      </Box>
    </Box>
  );
}
